import { render, staticRenderFns } from "./addTransfer.vue?vue&type=template&id=690a4228"
import script from "./addTransfer.vue?vue&type=script&lang=js"
export * from "./addTransfer.vue?vue&type=script&lang=js"
import style0 from "./addTransfer.vue?vue&type=style&index=0&id=690a4228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports